import React from 'react';
import Wizard from '../components/Wizard';
import { DcComponent, NodeComponent, PushServiceComponent, SoftwareStatus } from '../types';
import { calcStatus, STATUS_FILTER_ITEMS } from '../ComponentsOverviewUtils';
import { NODES_TYPES } from '../EnvironmentOverviewUtils';

const ComponentsSideBar: React.FC<{
    softwareStatus: SoftwareStatus;
    serversData: { nodes: NodeComponent[]; dcs: DcComponent[]; pushServices: PushServiceComponent[] };
}> = ({ softwareStatus, serversData }) => {
    const pushServicesStatusesMap = {};
    const nodesStatusesMap = {};
    const dcsStatusesMap = {};

    const pushServicesStatuses = serversData.pushServices.map((ps) =>
        calcStatus(ps.connected, ps.version, ps.inventoryName, softwareStatus, NODES_TYPES.PUSH_SERVICES)
    );

    const nodesStatuses = serversData.nodes.map((node) =>
        calcStatus(node.connected, node.version, node.inventoryName, softwareStatus, NODES_TYPES.NODES)
    );

    const dcsStatuses = serversData.dcs.map((dc) =>
        calcStatus(dc.connected, dc.version, dc.inventoryName, softwareStatus, NODES_TYPES.DCS)
    );

    pushServicesStatuses.forEach((status) => {
        if (pushServicesStatusesMap[status]) {
            pushServicesStatusesMap[status]++;
        } else {
            pushServicesStatusesMap[status] = 1;
        }
    });

    nodesStatuses.forEach((status) => {
        if (nodesStatusesMap[status]) {
            nodesStatusesMap[status]++;
        } else {
            nodesStatusesMap[status] = 1;
        }
    });

    dcsStatuses.forEach((status) => {
        if (dcsStatusesMap[status]) {
            dcsStatusesMap[status]++;
        } else {
            dcsStatusesMap[status] = 1;
        }
    });

    return (
        <Wizard.Sidebar className="h-fit w-full">
            <div className="flex flex-col gap-4 font-sf">
                {serversData?.pushServices?.length > 0 && (
                    <>
                        <div>
                            <div className="font-medium text-13 text-sf-gray-700 min-h-6 flex items-center">
                                Desktop Messaging Services ({serversData.pushServices.length})
                            </div>
                            {Object.keys(pushServicesStatusesMap).map((statusKey) => (
                                <div
                                    key={statusKey}
                                    className="flex items-center justify-between text-13 leading-[21px]">
                                    <span className="text-sf-gray-400">
                                        {STATUS_FILTER_ITEMS[statusKey]?.title || 'N/A'}
                                    </span>
                                    <span className="text-sf-gray-700">{pushServicesStatusesMap[statusKey]}</span>
                                </div>
                            ))}
                        </div>
                        <div className="h-px bg-sf-gray-100"></div>
                    </>
                )}
                <div>
                    <div className="font-medium text-13 text-sf-gray-700 min-h-6 flex items-center">
                        Nodes ({serversData.nodes.length})
                    </div>
                    {Object.keys(nodesStatusesMap).map((statusKey) => (
                        <div key={statusKey} className="flex items-center justify-between text-13 leading-[21px]">
                            <span className="text-sf-gray-400">{STATUS_FILTER_ITEMS[statusKey]?.title || 'N/A'}</span>
                            <span className="text-sf-gray-700">{nodesStatusesMap[statusKey]}</span>
                        </div>
                    ))}
                </div>
                <div className="h-px bg-sf-gray-100"></div>
                <div>
                    <div className="font-medium text-13 text-sf-gray-700 min-h-6 flex items-center">
                        DCs ({serversData.dcs.length})
                    </div>
                    {Object.keys(dcsStatusesMap).map((statusKey) => (
                        <div key={statusKey} className="flex items-center justify-between text-13 leading-[21px]">
                            <span className="text-sf-gray-400">{STATUS_FILTER_ITEMS[statusKey]?.title || 'N/A'}</span>
                            <span className="text-sf-gray-700">{dcsStatusesMap[statusKey]}</span>
                        </div>
                    ))}
                </div>
            </div>
        </Wizard.Sidebar>
    );
};

export default ComponentsSideBar;
